// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Donate_wrap__2L1A4","donateImg":"Donate_donateImg__3x59S"};